export enum eSigningMethod {
  ESign = 'e_sign',
  Notary = 'notary',
  WetSignature = 'wet_signature',
}

export const prettySigningMethod = {
  [eSigningMethod.ESign]: 'E-Sign',
  [eSigningMethod.Notary]: 'Notary',
  [eSigningMethod.WetSignature]: 'Wet Signature',
};

export const signingMethodOptions = Object.keys(prettySigningMethod)
  .map((t) => t as eSigningMethod)
  .map((key) => ({
    label: prettySigningMethod[key],
    value: key,
  }));
